
import { Grid, IconButton, Tooltip } from '@mui/material';
import './item-card.css';
import { useDispatch } from 'react-redux';
import { getById } from "src/services/articles.service";
import * as componentActions from 'src/redux/actions/articles';
import { Search } from '@mui/icons-material';

const ArticleCard = (props) => {
    const { article, intl, history, lang, setNotification, setLoading } = props

    const dispatch = useDispatch()

    const goToArticleEdit = async () => {
        if (article && article.id) {
            setLoading(true)
            const response = await getById(article.id)
            if (response.success && response.data) {
                setLoading(false)
                dispatch(componentActions.addCurrent(response.data))
            }
            setLoading(false)
            history.push(`/${lang}/articles-edit`)
        }
    }

    const goToArticle = async () => {
        if (article && article.id) {
            window.open(`${window.location.origin}/${lang}/article-external/${article.id}`, "_blank", "noopener,noreferrer")
        }
    }

    return (
        <Grid item container spacing={2} lg={12} md={11} sm={11} xs={12} className="cardItem" direction="row" alignItems="center" >
            <Grid item lg={2} md={2} sm={4} xs={4} style={{ display: "flex", alignItems: "center" }} onClick={goToArticleEdit}>
                <span className="boldLine-two" style={{ cursor: "pointer" }}>
                    ID {article.id}
                </span>
            </Grid>
            <Grid item lg={1} md={2} sm={1} xs={1} className='moreActions'>
                <Tooltip title={<h5>{intl.formatMessage({ id: "read.article" })}</h5>}>
                    <IconButton aria-label="table-popup" onClick={goToArticle} >
                        <Search />
                    </IconButton>
                </Tooltip>
            </Grid>
            <Grid item lg={4} md={4} sm={6} xs={6} style={{ display: "flex", alignItems: "center" }}>
                <span style={{ wordBreak: "break-word" }}>{article.title}</span>
            </Grid>
            <Grid item lg={5} md={5} sm={6} xs={6} style={{ display: "flex", alignItems: "center" }}>
                <span style={{ wordBreak: "break-word" }}>{article.subtitle}</span>
            </Grid>
        </Grid>
    )
}

export default ArticleCard;